import moment from "moment";
import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import dataHandler from "../../hooks/dataHandler";
import TableActions from "../../components/Common/TableActions";
import CustomPagination from "../../components/Common/CustomPagination";
import TableLayout from "../../components/TableLayout";
import Filter from "../../components/Common/Filter";

const InquiryManagement = () => {
  const [deleteModel, setDeleteModel] = useState({ show: false, dumpId: null });
  const {
    setBody,

    data,
    loader,
    paginationHandler,
    searchHandler,
    total,
    body,
  } = dataHandler({
    extraBody: {},
  });

  const columns = [
    {
      head: "Sr. No.",
      accessor: "#",
      component: (item, key) => <>{body.limit * (body.page - 1) + key + 1}</>,
    },
    { head: "First Name", accessor: "firstName" },
    { head: "Last Name", accessor: "lastName" },
    { head: "Email Address", accessor: "email" },
    { head: "Phone Number", accessor: "phoneNumber" },
    { head: "Description", accessor: "description" },
    {
      head: "Action",
      accessor: "Action",
      component: (item) => (
        <TableActions
          viewLink={`/inquiry/detail/${item._id}`}
          setDeleteModel={() =>
            setDeleteModel({ show: true, dumpId: item._id })
          }
          deleteBtn
        />
      ),
    },
  ];

  const dummyData = [
    {
      _id: "inq001",
      firstName: "Alice",
      lastName: "Johnson",
      email: "alice.johnson@example.com",
      phoneNumber: "123-456-7890",
      description: "Looking to rent a small conference room for 2 hours.",
      categoryName: "Conference Room",
    },
    {
      _id: "inq002",
      firstName: "Bob",
      lastName: "Smith",
      email: "bob.smith@example.com",
      phoneNumber: "987-654-3210",
      description: "Interested in renting a studio space for a photoshoot.",
      categoryName: "Studio",
    },
  ];

  return (
    <>
      <section className="inquiryManagement position-relative py-3">
        <Container>
          <Row>
            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                Inquiry Requests List
              </h4>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <Filter
                    body={body}
                    setBody={setBody}
                    searchHandler={searchHandler}
                    // filterByCategory={filterByCategory}
                  />
                </div>
         
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout column={columns} data={dummyData} />
              <CustomPagination
                total={total}
                pageChangeHandler={paginationHandler}
                body={body}
                setBody={setBody}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default InquiryManagement;
